<template>
    <template v-if="verfuegbar">
        <div class="versicherungs-button col col-12" :class="`col-md-${spalten}`" role="button" tabindex="0" @click="$emit('select')" @keydown.enter="$emit('select')" @keydown.space.prevent="$emit('select')">
            <input type="checkbox" :id="`zvp-${itemId}`" class="d-none" :checked="selected">
            <label class="d-flex flex-column p-3 border rounded w-100">
                <div class="d-flex justify-content-between align-items-center">
                    <span class="">
                        <zahnvorsorge_icon></zahnvorsorge_icon>
                    </span>
                    <h1>{{ beitragStr }}</h1>
                </div>
                <h3 class="mt-2">Zahnvorsorge <b>Premium</b></h3>
            </label>
        </div>
    </template>
</template>

<script setup>
import zahnvorsorge_icon from '@/components/icons/zahnvorsorge_icon.vue';

defineProps({
    itemId: {
        type: String,
        required: true
    },
    beitragStr: {
        type: String,
        default: '- €'
    },
    selected: {
        type: Boolean,
        default: false
    },
    verfuegbar: {
        type: Boolean,
        default: true
    },
    spalten: {
        type: Number,
        default: 6
    }
})

defineEmits(['select'])
</script>

<style scoped>
    h1, h3 {
        white-space: nowrap;     
        overflow-wrap: normal;   
        word-break: none;      
        hyphens: none;          
    }
</style>
